<xemex-page-header
  [title]="'sidebarMenu.installations' | translate"
  [breadcrumbs]="breadcrumbs"
  [withBackground]="false"
></xemex-page-header>

<xemex-page-body>
  <xemex-table
    [data]="tableData()"
    [columns]="columns()"
    [loading]="installationStore.isLoading()"
    [totalCount]="totalCount()"
    [rowLink]="rowLink"
    (pageChange)="onPageChange($event)"
  >
    <xemex-table-filter-bar
      [filterGroups]="filterGroups()"
      [searchPlaceholder]="'installations.filter.search' | translate"
      [initialFilters]="initialFilters()"
      [initialSearch]="initialSearch"
      (searchChange)="onSearchChange($event)"
      (filterChange)="onFilterChange($event)"
    >
      @if (canCreate()) {
        <xemex-filled-button actions type="button" icon="add" (click)="openCreateDialog()">
          {{ 'installations.create.action' | translate }}
        </xemex-filled-button>
      }
    </xemex-table-filter-bar>
  </xemex-table>
</xemex-page-body>
